import { snakeCase } from "lodash"
import { updateSpendVBudgetedTable, updateSpendVFeesTable } from "../src/reports"
import { downloadLink } from "../src/tools"
import { formatDate } from "../src/utils"

let spendVBudgetedRequest, spendVFeesRequest

function bindSpendVBudgetedPage() {
  new CraftySelect2({
    select: jQuery(".spend-v-budgeted-content #budget_id"),
    onSelect: fetchClientSpendVsBudgetedReports,
    onUnselect: fetchClientSpendVsBudgetedReports,
  }).init()

  jQuery('.spend-v-budgeted-content .date-holder').on('dateSelected', function() {
    fetchClientSpendVsBudgetedReports()
  })

  jQuery(".spend-v-budgeted-content input[name='budget-view-toggle']").change(function() {
    fetchClientSpendVsBudgetedReports()
  })
  intitalizeClientSpendVFeesBreakdownChart()
  bindDetailLinks()
  bindSpendVBudgetedDownload()
}

function bindDetailLinks() {
  jQuery('.spend-v-budgeted-content .snapshot-link').on('click', function(e) {
    e.stopPropagation()
    const baseUrl = jQuery(this).data('link')
    const data = getFilterData()
    const selected = jQuery(".spend-v-budgeted-content #budget_id").val()
    const params = $.param({ ...data, selected })
    const fullPath = baseUrl + '?' + params
    window.location.href = fullPath 
  })
}

function fetchClientSpendVsBudgetedReports() {
  const data = getFilterData()
  const url = jQuery("#spend-v-budgeted-wrapper").data("link")
  if (data.row_type !== '') {
    fetchSpendVBudgetedReport(url, { ...data, report_name: "spend_v_budgeted" } )
    fetchSpendVFeesBreakdownReport(url, { ...data, report_name: "spend_v_fees_breakdown" } )
  }
}

function bindSpendVBudgetedDownload() {
  jQuery('.spend-v-budgeted-download-link').click(downloadSpendVBudgetedReport)
}

function downloadSpendVBudgetedReport(e) {
  e.preventDefault()
  const filterData = getFilterData()
  const link = jQuery(this).data('link')
  if (filterData && !filterData.budget_id && !filterData.budget_group_id) return
  downloadLink(link, filterData)
}

function getFilterData() {
  const from_range = formatDate(jQuery(".spend-v-budgeted-content #range_from").val())
  const to_range = formatDate(jQuery(".spend-v-budgeted-content #range_to").val())
  const group = reportGrouping()
  const $selectedBudget = jQuery(".spend-v-budgeted-content #budget_id")
  const selectedValue = $selectedBudget.val()
  const [row_type, id] = selectedValue.split("-")
  return { [`${snakeCase(row_type)}_id`]: id, row_type, to_range, group, from_range }
}

function reportGrouping() {
  if (jQuery(".spend-v-budgeted-content #month-filter").is(':checked')) return 'month'
  if (jQuery(".spend-v-budgeted-content #quarter-filter").is(':checked')) return 'quarter'
}

function fetchSpendVBudgetedReport(url, data) {
  spendVBudgetedRequest = jQuery.ajax({
    url,
    type: "GET",
    dataType: "json",
    data,
    success: function(res) {
      const { labels, datasets } = res.data
      const element = document.getElementById('spend-v-budgeted-chart-vue-app')
      const event = new CustomEvent('spend-v-budgeted-data-updated', { detail: { labels: labels, datasets: datasets } })
      element.dispatchEvent(event)
      const $table = $('#spend-v-budgeted-table')
      updateSpendVBudgetedTable($table, { labels, datasets })    
    },
    beforeSend: function () {
      if (spendVBudgetedRequest != null) {
        spendVBudgetedRequest.abort()
      }
    },
    complete: function () {
      spendVBudgetedRequest = null
    },
  })
}

function fetchSpendVFeesBreakdownReport(url, data) {
  spendVFeesRequest = jQuery.ajax({
    url,
    type: "GET",
    dataType: "json",
    data,
    success: function(res) {
      const { labels, datasets } = res.data
      const element = document.getElementById('spend-v-budgeted-chart-vue-app')
      const event = new CustomEvent('spend-v-fees-data-updated', { detail: { labels: labels, datasets: datasets } })
      element.dispatchEvent(event)
      const $table = $('#spend-v-fees-table')
      updateSpendVFeesTable($table, { labels, datasets })    
    },
    beforeSend: function () {
      if (spendVFeesRequest != null) {
        spendVFeesRequest.abort()
      }
    },
    complete: function () {
      spendVFeesRequest = null
    },
  })
}

function intitalizeClientSpendVFeesBreakdownChart() {
  console.log("Initializing Client Spend vs Fees Breakdown Chart") 
  fetchClientSpendVsBudgetedReports()
}

window.bindSpendVBudgetedPage = bindSpendVBudgetedPage
